import type { PurchaseLoadStatus } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadRevertStatusAtom = createMutationAtomFactory(
  'trade.purchaseLoadRevertStatus',
  (params: { id: string; targetStatus: PurchaseLoadStatus }) => ({
    tradePurchaseLoadRevertStatus: {
      __args: { id: params.id, targetStatus: params.targetStatus },
      id: true,
      status: true,
    },
  }),
);
